import React from "react";
import { styled } from "@mui/system";
import MUIMenuItem from "@mui/material/MenuItem";
import {
  MenuItemProps as MenuItemPropsMUI,
  MenuItemOwnProps
} from "@mui/material/MenuItem";
import {
  ExtendButtonBase,
  ExtendButtonBaseTypeMap
} from "@mui/material/ButtonBase";

export type MenuItemProps = {
  group?: boolean;
  component?: React.ElementType;
} & MenuItemPropsMUI;

const MenuItemRoot = styled(
  React.forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => {
    return <MUIMenuItem ref={ref} {...props} />;
  }),
  {
    name: "MenuItem",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "group",
    overridesResolver: (props, styles) => []
  }
)<{ group?: boolean }>(({ theme, group }) =>
  theme.name === "fic"
    ? {
        paddingTop: 10,
        paddingBottom: 10,
        "&.MuiMenuItem-root.MuiMenuItem-gutters.MuiButtonBase-root": {
          paddingLeft: group ? "40px" : "16px"
        },
        "&.MuiMenuItem-root.MuiButtonBase-root": {
          "&:hover": {
            background: theme.palette.primary.surfaceHover,
            border: "1px solid transparent"
          },
          "&.Mui-selected": {
            background: theme.palette.primary.interactiveSelected
          }
        }
      }
    : {
        paddingTop: "10px",
        paddingBottom: "10px",
        "&.MuiMenuItem-root.MuiMenuItem-gutters.MuiButtonBase-root": {
          paddingLeft: group ? "40px" : "16px"
        },
        "&.MuiMenuItem-root.MuiButtonBase-root": {
          "&:hover": {
            background: theme.palette.primary.surfaceDefault,
            border: "1px solid #0090D1"
          }
        }
      }
);

export type MenuItemTypeMap<
  AdditionalProps = {},
  RootComponent extends React.ElementType = "li"
> = ExtendButtonBaseTypeMap<{
  props: AdditionalProps & MenuItemProps;
  defaultComponent: RootComponent;
}>;

export const MenuItem = React.forwardRef<HTMLLIElement, MenuItemProps>(
  function MenuItem(props, ref) {
    return <MenuItemRoot {...props} ref={ref} />;
  }
) as ExtendButtonBase<MenuItemTypeMap<{}, "li">>;
